/**
 * 사진 뷰어(viewerjs / v-viewer) 공통: 확대 안 한 상태에서 좌우로 밀면 사진 위치를 옮기지 않고 이전·다음 사진으로
 * - 확대했을 때는 기존처럼 끌어서 사진 이동
 * - main.js 의 VueViewer defaultOptions 에 넣어 모든 뷰어에 적용 (화면별 options 에 move/shown/hidden 을 따로 주면 그 화면은 덮어씀)
 */
function isZoomed(v) {
    return !!(v && v.imageData && v.initialImageData && v.imageData.ratio > v.initialImageData.ratio + 0.001);
}

function bind(v) {
    if (!v || !v.canvas) return;
    unbind(v);
    let start = null;
    if (!v.canvas.__swipeDown) {
        //캔버스는 뷰어가 살아 있는 동안 그대로라 한 번만
        v.canvas.__swipeDown = (e) => { v.__swipeStart = e.isPrimary ? { x: e.clientX, y: e.clientY, zoomed: isZoomed(v) } : null; };
        v.canvas.addEventListener('pointerdown', v.canvas.__swipeDown, true);
    }
    //손을 캔버스 밖에서 뗄 수도 있어서 window 에서 받음 (뷰어 닫히면 지움)
    v.__swipeUp = (e) => {
        start = v.__swipeStart; v.__swipeStart = null;
        if (!start || !e.isPrimary || start.zoomed || v.length <= 1) return;
        const dx = e.clientX - start.x, dy = e.clientY - start.y;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        if (dx < 0) v.next(true); else v.prev(true);
    };
    window.addEventListener('pointerup', v.__swipeUp, true);
}

function unbind(v) {
    if (v && v.__swipeUp) window.removeEventListener('pointerup', v.__swipeUp, true);
    if (v) v.__swipeUp = null;
}

export const viewerSwipeOptions = {
    //이 훅들의 this·e.target 은 뷰어를 붙인 요소, 요소.viewer 가 뷰어
    move(e) { const v = e.target && e.target.viewer; if (v && !isZoomed(v)) e.preventDefault(); },
    shown(e) { bind(e.target && e.target.viewer); },
    hidden(e) { unbind(e.target && e.target.viewer); },
};
